import React from 'react';
import { Paper, styled, css, Menu, MenuProps, ButtonBase } from '@mui/material';

export const HeaderWrapper = styled(Paper)(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 2,
  display: 'flex',
  borderRadius: 0,
}));

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(
  ({ theme }) => css`
    & .MuiPaper-root {
      min-width: 250px;
      border-radius: ${theme.shape.borderRadius};
      padding: 0;
      background: #fff;
      margin-top: ${theme.spacing(5)};
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.13);
    }

    & .MuiList-root {
      padding: 0;
    }

    & .MuiMenuItem-root {
      padding: ${theme.spacing(3)} ${theme.spacing(5)};
      color: ${theme.palette.text.primary};

      &:hover {
        background: ${theme.palette.primary.light};
      }

      &.active .MuiListItemText-primary {
        font-weight: 700;
      }
    }
  `
);

export const MenuButton = styled(ButtonBase)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    padding: ${theme.spacing(2)};
    border-radius: ${theme.shape.borderRadius * 2}px;
    border: none;
    transition: all 150ms ease;
    cursor: pointer;
    background: ${theme.palette.primary.light};
    color: ${theme.palette.text.primary};
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);

    &:hover {
      background: ${theme.palette.rose[200]};
    }

    &:focus-visible {
      box-shadow: 0 0 0 4px ${theme.palette.primary.light};
      outline: none;
    }
  `
);
